// Carry the selected product into the enquiry without replacing customer input.
(() => {
  const field = document.getElementById('ContactForm-product');
  if (!field || field.value) return;
  const product = new URLSearchParams(window.location.search).get('product');
  if (product) field.value = product.slice(0, 300);
})();
